import {translations} from 'presentation/translations-new';

const {confirm, professional, exam, unit, location, neighborhood, hourAndProfessional} =
	translations['pt-br'].privateFlow.bookingFlow.steps;

const EXAMS_LABELS = [location, exam, neighborhood, unit, professional, confirm];
const EXAMS_LABELS_WITHOUT_DISTRICT = [location, exam, unit, professional, confirm];
const EXAMS_LABELS_ADVANCE_DIAGNOSTICS = [exam, hourAndProfessional, confirm];

export {EXAMS_LABELS, EXAMS_LABELS_WITHOUT_DISTRICT, EXAMS_LABELS_ADVANCE_DIAGNOSTICS};
